import { log } from "../../../";

import * as React from "react";
import { observer } from "mobx-react";
import { action } from "mobx";

import CardTitleEditor from "../CardTitleEditor";
import { CategoryTypeSelector } from "./CategoryTypeSelector";
import { PreviewDialog } from "./PreviewDialog";
import { FolderBrowser } from "../../folderBrowser/FolderBrowser";

import Dialog from "@material-ui/core/Dialog";

import * as CustomLists from "../../../models/customLists";
import { BrowseListsStore } from "../../../stores/BrowseListsStore";

import { strings } from "../../../core/localizedStrings";

export interface BrowseListsViewDialogsProps extends React.Props<any> {
    store: BrowseListsStore;
}

@observer
export class BrowseListsViewDialogs extends React.Component<BrowseListsViewDialogsProps> {
    render() {
        log.verbose("Rendering dialogs...");
        if (this.props.store.folderToEdit !== undefined) {
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.store.folderToEdit !== undefined}
                    onClose={this.onCategoryFolderEditClose}
                >
                    <CardTitleEditor
                        description={strings.folderName}
                        title={this.props.store.folderToEdit.title}
                        onEditCompleteCallback={this.onEditCategoryFolderTitle}
                    />
                </Dialog>
            );
        } else if (this.props.store.shouldShowCategoryListSelector) {
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.store.shouldShowCategoryListSelector}
                    onClose={this.onCategoryTypeSelectorClose}
                >
                    <CategoryTypeSelector onCategoryTypeSelectedCallback={this.onCategoryTypeSelected} />
                </Dialog>
            );
        } else if (this.props.store.shouldShowPreview) {
            return <PreviewDialog store={this.props.store} />;
        } else if (this.props.store.favoriteToAdd) {
            this.props.store.fetchRootFolderListForFolderBrowser(CustomLists.TabSelection.FAVORITES);
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.store.favoriteToAdd !== undefined}
                    onClose={this.onFavoriteFolderBrowserClose}
                >
                    <FolderBrowser
                        titleMessage={strings.selectFolderToAddFavoriteTo}
                        onFolderSelected={this.onFavoritesFolderSelected}
                        store={this.props.store}
                    />
                </Dialog>
            );
        } else if (this.props.store.itemToMove) {
            this.props.store.fetchRootFolderListForFolderBrowser(this.props.store.currentTab);
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.store.itemToMove !== undefined}
                    onClose={this.onCategoryToMoveFolderBrowserClose}
                >
                    <FolderBrowser
                        titleMessage={strings.moveListTo}
                        onFolderSelected={this.onCategoryToMoveFolderSelected}
                        store={this.props.store}
                    />
                </Dialog>
            );
        } else if (this.props.store.folderToMove) {
            this.props.store.fetchRootFolderListForFolderBrowser(this.props.store.currentTab);
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.store.folderToMove !== undefined}
                    onClose={this.onFolderToMoveFolderBrowserClose}
                >
                    <FolderBrowser
                        titleMessage={strings.moveFolderTo}
                        onFolderSelected={this.onFolderToMoveFolderSelected}
                        store={this.props.store}
                    />
                </Dialog>
            );
        } else if (this.props.store.itemToCopy) {
            this.props.store.fetchRootFolderListForFolderBrowser(CustomLists.TabSelection.MY_LISTS);
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.store.itemToCopy !== undefined}
                    onClose={this.onCategoryToCopyFolderBrowserClose}
                >
                    <FolderBrowser
                        titleMessage={strings.createCopyIn}
                        onFolderSelected={this.onCategoryToCopyFolderSelected}
                        store={this.props.store}
                    />
                </Dialog>
            );
        } else {
            return null;
        }
    }

    // Category Type Selector
    private onCategoryTypeSelected = async (type: CustomLists.CategoryType) => {
        await this.props.store.createAndSetRootFolderIfNecessary();

        let newCategory: CustomLists.Category = new CustomLists.Category();
        newCategory.type = type;
        newCategory.parentKey = this.props.store.visibleFolder.key;
        this.props.store.setCategoryItemToCreate(newCategory);

        this.props.store.setShouldShowCategoryListSelector(false);
    };

    private onCategoryTypeSelectorClose = () => {
        this.props.store.setShouldShowCategoryListSelector(false);
    };

    // Folder Browser
    @action
    private onFavoriteFolderBrowserClose = () => {
        this.props.store.favoriteToAdd = undefined;
    };

    private onFavoritesFolderSelected = (folder: CustomLists.Folder) => {
        this.props.store.addFavoriteToFolder(folder);
    };

    // Move Category
    private onCategoryToMoveFolderBrowserClose = () => {
        this.props.store.setItemToMove(undefined);
    };

    private onCategoryToMoveFolderSelected = (folder: CustomLists.Folder) => {
        if (this.props.store.visibleFolder.key !== folder.key) {
            this.props.store.moveItemToFolder(this.props.store.itemToMove, folder, this.props.store.currentTab);
        }
    };

    private onFolderToMoveFolderBrowserClose = () => {
        this.props.store.setFolderToMove(undefined);
    };

    private onFolderToMoveFolderSelected = (folder: CustomLists.Folder) => {
        if (this.props.store.visibleFolder.key !== folder.key) {
            this.props.store.moveFolderToFolder(this.props.store.folderToMove, folder, this.props.store.currentTab);
        }
    };

    // Copy Category
    @action
    private onCategoryToCopyFolderBrowserClose = () => {
        this.props.store.itemToCopy = undefined;
    };

    private onCategoryToCopyFolderSelected = (folder: CustomLists.Folder) => {
        this.props.store.copyCategoryToFolder(folder);
    };

    // Edit Image Folder Actions
    private onCategoryFolderEditClose = () => {
        this.props.store.setFolderTitleToEdit(undefined);
    };

    private onEditCategoryFolderTitle = (newTitle: string) => {
        this.props.store.folderToEdit!.title = newTitle;
        this.props.store.updateFolder(this.props.store.folderToEdit!);
        this.props.store.setFolderTitleToEdit(undefined);
    };
}
